import ol_geom_Point from 'ol/geom/Point';
import SingleFeature from './Singlefeature';
import { SELECTED_FEATURE } from '../../utils/styles/styles';

/**
 * A layer which draw an selected area.
 * @constructor
 * @extends {SingleFeature}
 * @param {Object} opt_options Control options, extends olx.layer.VectorOptions.
 */
export default class Selection extends SingleFeature {
  constructor(opt_options) {
    const options = opt_options || {};

    options.style = SELECTED_FEATURE;

    super(options);

    this.currentStyle = options.style;

    this.isPointDraw = false;
  }

  /**
     * Set if draw point is needed.
     * @param {boolean} isDrawPoint Need to draw point.
     */
  setDrawPoint(isDrawPoint) {
    this.isPointDraw = isDrawPoint;
  }

  /**
     * Get the setted style.
     * @returns The setted style.
     */
  getStyle() {
    return this.currentStyle;
  }

  /**
     * Set a new selection feature style.
     * @param {ol.style.Style} style The style to set.
     */
  setStyle(style) {
    this.currentStyle = style;
    super.setStyle((feature) => {
      let styleToRet;
      if (!this.isPointDraw && feature instanceof ol_geom_Point) {
        styleToRet = undefined;
      } else {
        styleToRet = style;
      }
      return styleToRet;
    });
  }
}
